import React from "react";
import { FormattedMessage } from "react-intl";
import RBXAnimation from "@default/general-components/rbx-animation/rbx-animation";
import { useSelector } from "react-redux";
import RBXLogo from "@default/assets/rbx-company/RBX-Logo-white.svg?url";

const Error404 = () => {
  const microSite = useSelector((reduxStore) => reduxStore.appStore.microSite);

  return (
    // data-http-status-code is read back out of the final rendered HTML by
    // server.js to set the real HTTP status code (React Router v6's
    // StaticRouter no longer forwards a context object into rendered routes,
    // so there's no context.statusCode to read, and Helmet's side-channel
    // state leaks across renderToStringWithData's intermediate render passes
    // — e.g. NodeWrapper renders this component again while a query is still
    // loading — so it can't be used to detect the *final* page status either).
    <div className="container error-404" data-http-status-code="404">
      <div className="row">
        <div className="col-12">
          <h1 className="text-center">
            <FormattedMessage id="error.not_found" />
          </h1>
          {microSite ? (
            <img src={RBXLogo} className="rbx-logo" alt={"Logo RBX"} />
          ) : (
            <RBXAnimation />
          )}
        </div>
      </div>
    </div>
  );
};

export default Error404;
